import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { AppointmentScheduleModel } from '../models/appointment_schedule_model';
import { CustomContentsServant } from 'data-ng-custom-text';

export type GetAppointmentScheduleLabelCommand = () => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'getAppointmentScheduleLabelCommand',
    (
      defineCommandORM: IDefineCommand,
      ngAppointmentScheduleModel: AppointmentScheduleModel,
      ngCustomContentsServant: CustomContentsServant
    ) =>
      defineCommandORM('getAppointmentScheduleLabelCommand', (deferred) => {
        ngCustomContentsServant
          .getButtonLabel('Schedule an Appointment')
          .then((label) => {
            ngAppointmentScheduleModel.write({ label: label });
          })
          .catch(() => {
            ngAppointmentScheduleModel.write({ label: 'Appointment Schedule' });
          })
          .finally(() => deferred.resolve());
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/aside/scheduler_navigation/commands/get_appointment_schedule_label_command.ts